/* eslint-disable jsx-a11y/label-has-associated-control */
import * as PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import getRGB from '../../v2/style-helper/getRGB';
import doMetric from '../../v2/tracking/bigQueryMetricRecorder';
import Track from '../../v2/utils/tracking';

const getBoxShadow = (props, size) => {
  const rgbValue = getRGB(props.theme.checkbox?.boxShadow || props.theme.core.brand);
  return `0 0 0 ${size}px rgb(${rgbValue.r}, ${rgbValue.g}, ${rgbValue.b}, 0.5)`;
};

const getBorderColour = (props) => {
  if (props.checked && props.theme.checkbox?.borderColor) return props.theme.checkbox.borderColor;
  
  if (props.checked) return props.theme.core.brand;
  
  return '#8c8c8c'; // default / unchecked
};

const getBackgroundColour = props => (props.theme.checkbox?.backgroundColor ? props.theme.checkbox.backgroundColor : props.theme.core.brand);

const useStyles = createUseStyles({
  checkBoxInput: {
    // Replicating ScreenReaderOnly (can't use actual component and still use :checked)
    position: 'absolute',
    width: 1,
    height: 1,
    margin: -1,
    padding: 0,
    border: 0,
    clip: 'rect(0 0 0 0)',
    
    '&:focus + #styledLabel': {
      boxShadow: props => getBoxShadow(props, 3),
      border: props => `1px solid ${getBorderColour(props)}`,
      borderRadius: 4,
    },
    
    '&:checked + #styledLabel': {
      position: 'relative',
      backgroundColor: props => getBackgroundColour(props),
      
      '&:after': {
        content: '""',
        position: 'absolute',
        left: 5,
        width: 5,
        height: 12,
        border: 'solid #fff',
        borderWidth: '0 3px 3px 0',
        transform: 'rotate(35deg)',
      },
    },
  },
  styledLabel: {
    width: 20,
    height: 20,
    marginTop: 1,
    border: props => `1px solid ${getBorderColour(props)}`,
  },
});

export default function Checkbox(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const handleChange = (event) => {
    props.handleChange(event);
    
    try {
      doMetric('CheckBox', [{name: 'CheckboxId', value: props.id}]);
    } catch (error) {
      Track.track(error);
    }
  };
  
  return (
    <>
      <input
        id={props.id}
        className={classes.checkBoxInput}
        type="checkbox"
        value={props.value}
        onChange={handleChange}
        checked={props.checked}
      />
      <label
        className={classes.styledLabel} htmlFor={props.id} id="styledLabel" data-test={props.id} />
    </>
  );
}

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  handleChange: PropTypes.func,
};
